import axios from 'axios';
import { AuthResponse, User, InventoryItem, ClickResponse, Enemy, BattleState } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  getGoogleAuthUrl: (): string => {
    return `${API_BASE_URL}/auth/google`;
  },

  getProfile: async (): Promise<{ user: User }> => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
  },
};

export const gameAPI = {
  getInventory: async (): Promise<{ inventory: InventoryItem[] }> => {
    const response = await api.get('/game/inventory');
    return response.data;
  },

  click: async (): Promise<ClickResponse> => {
    const response = await api.post('/game/click');
    return response.data;
  },

  attack: async (): Promise<{
    damageDealt: number;
    currentEnemy: Enemy;
    enemyDefeated: boolean;
    droppedItem?: InventoryItem;
    battleState: BattleState;
  }> => {
    const response = await api.post('/game/attack');
    return response.data;
  },

  getBattleState: async (): Promise<{ battleState: BattleState }> => {
    const response = await api.get('/game/battle-state');
    return response.data;
  },

  defeatEnemy: async (enemyId: number): Promise<{
    droppedItem?: InventoryItem;
    newEnemy?: Enemy;
    battleState: BattleState;
  }> => {
    const response = await api.post('/game/defeat-enemy', { enemyId });
    return response.data;
  },

};

export default api;
